import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions/index";
import sampleCombine from 'xstream/extra/sampleCombine'

export function requestPersons(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_PERSONS)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/people' + (
        action.payload && action.payload.filter?
          `?filter=${JSON.stringify(action.payload.filter)}`:''
      ),
      category: 'requestPersons',
      method: 'GET',
      headers: { Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestPersons')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getPersonsSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestPersonsFail(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestPersons')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getPersonsFail(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/persons.js